import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getVehiclesStatus } from '../../services/VehiclesService';
import { VehiclesStatusResponse } from '../../types/Vehicles';

function useGetVehiclesStatus(fleetId: string, query = ''): UseQueryResult<VehiclesStatusResponse> {
  return useQuery(
    ['vehicles-status', fleetId],
    async (): Promise<VehiclesStatusResponse> => getVehiclesStatus(fleetId, query),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
    },
  );
}

export default useGetVehiclesStatus;
